/**
 * Check API response for rank-up events and dispatch to App.js
 */
export const checkRankUp = (data) => {
  const pointsResult = data?.points_result;
  if (pointsResult?.rank_up && pointsResult?.new_rank_name) {
    window.dispatchEvent(new CustomEvent('rankUp', {
      detail: {
        rankName: pointsResult.new_rank_name,
        rankKey: pointsResult.current_rank?.key
      }
    }));
  }
  return pointsResult;
};
